export enum SeatType {
  ADMIN = 'ADMIN',
  USER = 'USER',
}

export interface SeatAssignment {
  id: string;
  userId: string;
  seatType: SeatType;
  assignedAt: string;
  revokedAt?: string;
}

export interface AssignSeatInput {
  userId: string;
  seatType: SeatType;
}

export interface RevokeSeatInput {
  seatAssignmentId: string;
}

export interface getOrganizationSeatAssignmentsRequest {
  getOrganizationSeatAssignments: SeatAssignment[];
}

export interface assignSeatRequest {
  assignSeat: SeatAssignment;
}

export interface revokeSeatRequest {
  revokeSeat: SeatAssignment;
}
